export default "__VITE_ASSET__CXyuMGMG__"